/**
 * Responsibility: Implement history window behavior for the ui/helpers surface.
 * Scope: Owns ui/helpers concerns only; cross-surface orchestration is excluded.
 */
import type { HistoryEntry } from "@anyquest/shared-core"
const DEFAULT_ACTIVE_SCENE_MAX = 6
function normalizeLocation(name: string | undefined | null): string {
  return String(name ?? '').trim().toLowerCase()
}

export function getActiveSceneTailCount(
  history: HistoryEntry[],
  maxEntries = DEFAULT_ACTIVE_SCENE_MAX,
): number {
  if (!Array.isArray(history) || history.length === 0) return 0
  const cap = Math.max(1, Math.floor(maxEntries))
  const latestLocation = normalizeLocation(history[history.length - 1]?.location)
  let count = 1
  for (let i = history.length - 2; i >= 0; i -= 1) {
    if (count >= cap) break
    if (normalizeLocation(history[i]?.location) !== latestLocation) break
    count += 1
  }

  return Math.min(count, cap, history.length)
}

export function getActiveSceneEntries(history: HistoryEntry[], maxEntries = DEFAULT_ACTIVE_SCENE_MAX): Array<HistoryEntry & { isLatest: boolean }> {
  const tailCount = getActiveSceneTailCount(history, maxEntries)
  if (tailCount <= 0) return []
  const start = history.length - tailCount
  return history.slice(start).map((entry, idx) => ({
    ...entry,
    isLatest: (start + idx) === (history.length - 1),
  }))
}
